import api from '../../../../App/socket';

export const removeUserProfileGroupsList = (user_id, del_groups) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'DelUserFromGroup',
        options: { user_id, del_groups },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_groups_requests/remove_groups_list.js